import { render, staticRenderFns } from "./vf-drawer-widget.vue?vue&type=template&id=4a1e097a&scoped=true&"
import script from "./vf-drawer-widget.vue?vue&type=script&lang=js&"
export * from "./vf-drawer-widget.vue?vue&type=script&lang=js&"
import style0 from "./vf-drawer-widget.vue?vue&type=style&index=0&id=4a1e097a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e097a",
  null
  
)

export default component.exports